// Components
import List from '@/components/global-components/list/List';

// Themes
import theme from '@/themes/index';

const InstitutionDetails = ({
  content: {
    logoImage, 
  },
  institutionHighlights,
}) => {
  return (
    <>
      <div className='information-card-container'>
        <div className='logo-container'>
          <a href='https://acreditacion.cervantes.es/default.htm'><img src={logoImage.url}></img></a>
          <p><a href='/location/heredia'>CPI Heredia</a> is the campus approved by Instituto Cervantes</p>
        </div>
        <List content={institutionHighlights} />
      </div>
      <style jsx>{`
        div.information-card-container .logo-container {
          padding: 3.25rem 0 2.25rem;
          display: flex;
          flex-direction: column;
          width: 100%;
          align-items: center;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.information-card-container .logo-container {
            padding: 6rem 0;
            align-items: flex-start;
            display: flex;
            flex-direction: row;
            justify-content: center;
            gap: 20px;
            align-items: center;
          }

          div.information-card-container .logo-container p {
            font-size: 1.3rem;
            text-decoration: none;
            color: #00E065;
            font-family: MontserratSemiBold;
          }
          
        }
      `}</style>
      <style global jsx>{`
        div.institution-details h6 {
          color: #00E065;
        }

        div.institution-details ul li::marker {
          color: #00E065;
        }
      `}</style>
    </>
  );
};

export default InstitutionDetails;
